import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-failed-payments-table',
  templateUrl: './failed-payments-table.component.html',
  styleUrls: ['./failed-payments-table.component.css']
})
export class FailedPaymentsTableComponent {
  @Input() data: any[] = [];
  @Input() mode: 'retiros' | 'transferencias' = 'retiros';
  @Output() process = new EventEmitter<any>();

  mangopayUrl = environment.mangopayUrl;

  getTransferUrl(item: any) {
    // Por requerimiento: transferencias usan la ruta transfer
    return item?.transferId ? `${this.mangopayUrl}transfer/${item.transferId}` : null;
  }

  getPayoutUrl(item: any) {
    return item?.withdrawId ? `${this.mangopayUrl}payout/${item.withdrawId}` : null;
  }

  getTransferStatus(item: any): 'success' | 'failed' | 'unknown' {
  const section = (item?.section || '').toString().toLowerCase();
  if (section === 'transfer') return 'failed';
  if (section === 'payout') return 'success';
  if (!item?.transferId) return 'unknown';
  return item?.withdrawId ? 'success' : 'failed';
  }

  getPayoutStatus(item: any): 'failed' | 'no-realizado' {
    // Solo mostramos fallidos o no realizado
    if (!item?.withdrawId) return 'no-realizado';
    return 'failed';
  }
}
